export interface ICompensation {
  code?: string;
  currency?: string;
  minAmount: null | number;
  maxAmount: null | number;
  minAmountUSD?: number;
  periodicity?: string;
  visible?: boolean;
  estimate?: boolean;
  conversionCurrency?: string;
  minAmountConverted?: null | number;
  maxAmountConverted?: null | number;
}

export enum CompensationType {
  FIXED = "fixed",
  RANGE = "range",
  UNPAID = "unpaid",
  GET_QUOTES = "get-quotes",
  TO_BE_AGREED = "to-be-agreed"
}

export class Compensation {
  public code?: string;
  public currency?: string;
  public minAmount: null | number;
  public maxAmount: null | number;
  public minAmountUSD?: number;
  public periodicity?: string;
  public visible?: boolean;
  public estimate?: boolean;
  public conversionCurrency?: string;
  public minAmountConverted?: null | number;
  public maxAmountConverted?: null | number;

  constructor(data: ICompensation) {
    this.code = data.code || (data.minAmount ? data.maxAmount ? "range" : "fixed" : "unpaid");
    this.currency = data.currency;
    this.minAmount = data.minAmount;
    this.maxAmount = data.maxAmount;
    this.minAmountUSD = data.minAmountUSD;
    this.periodicity = data.periodicity;
    this.visible = data.visible;
    this.estimate = data.estimate;
    this.conversionCurrency = data.conversionCurrency;
    this.minAmountConverted = data.minAmountConverted;
    this.maxAmountConverted = data.maxAmountConverted;
  }

  public currencySymbol(): string {
    return this.currency ? this.currency.slice(3) : "";
  }

  public currencyText(): string {
    return this.currency ? this.currency.slice(0, 3) : "";
  }

  public minUSDAmount(): string {
    return this.minAmountUSD ? this.minAmountUSD.toFixed(2) : "";
  }
}
